module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Label Details</span></div>\r\n<div class=\"main-slider-caption prop-detail\" >\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Min</label> \r\n            <div>\r\n                <input type=\"text\" value=\"")
    ; __append(escapeFn(minText))
    ; __append("\" name=\"minText\"  />\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Max</label> \r\n            <div>\r\n                <input type=\"text\" value=\"")
    ; __append(escapeFn(maxText))
    ; __append("\" name=\"maxText\"/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}